import { useState } from 'react';
import { CmmFileHeader } from '../../../shared/types/cmmReport.ts';
import { formatDatetime } from '../../utils/fieldFormats.ts';
import { ClearFiltersButton } from '../clearFiltersButton.tsx';
import { ModalSubmitDialog } from '../modalSubmitDialog.tsx';
import { ToggleButton } from '../toggleButton.tsx';


interface CmmReportExt extends CmmFileHeader {
    index: number;
    isSelected: boolean;
}

interface Props {
    isOpen: boolean;
    cmmReports: CmmFileHeader[];
    initialFilter?: string;
    onCancel: () => void;
    onSubmit: (cmmReports: CmmFileHeader[]) => void;
}

export function CmmFilesDialog({
    isOpen,
    cmmReports: _cmmReports,
    initialFilter,
    onCancel,
    onSubmit,
}: Props) {
    const [cmmReports, setcmmReports] = useState<CmmReportExt[]>(
        _cmmReports.map((it, index) => ({
            ...it,
            index,
            isSelected: false,
        }))
    );
    const [filterInput, setFilterInput] = useState(initialFilter ?? '');


    const handleSelectionChange = (index: number, isSelected: boolean) => {
        const newCmmReports = [...cmmReports];
        newCmmReports[index].isSelected = isSelected;
        setcmmReports(newCmmReports);
    };

    const handleSubmit = () => {
        const selectedReports = cmmReports.filter(it => it.isSelected);
        onSubmit(selectedReports);
    };


    const filteredCmmReports = cmmReports.filter(it => it.name.toLowerCase().includes(filterInput.toLowerCase()));

    if (!isOpen) return null;
    return (
        <ModalSubmitDialog
            isOpen={isOpen}
            onCancel={onCancel}
            onSubmit={handleSubmit}
        >
            <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                <div>Filter:</div>
                <input
                    style={{ marginLeft: '5px' }}
                    type='text'
                    placeholder='Search'
                    value={filterInput}
                    onChange={e => setFilterInput(e.target.value)}
                />
                <ClearFiltersButton onClick={() => { setFilterInput('') }} />
            </div >

            <table className='table--cmm-reports-list'>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Time</th>
                        <th>Import</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredCmmReports?.map(it => (
                        <tr key={it.name}>
                            <td>{it.name}</td>
                            <td>{formatDatetime(it.lastModified)}</td>
                            <td>
                                <ToggleButton
                                    selection={it.isSelected}
                                    onSelectionChange={(isSelected) => handleSelectionChange(it.index, isSelected)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </ModalSubmitDialog >
    )
}
